import React, { useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify'

const initialState = {
    name: '',
    number: '',
    subject: '',
    message: '',
    errors: {},
}

const toastOptions = { position: 'top-right', autoClose: 5000 }

const ContactForm = () => {
    const [cState, updateCState] = useState(initialState)
    const [submitting, setSubmitting] = useState(false)
    const { name, number, subject, message, errors } = cState

    const handleInputChange = (e) => {
        const { name, value } = e.target
        updateCState({ ...cState, [name]: value, errors: {} })
    }

    const handleValidation = () => {
        const error = {}
        if (!name.trim()) error.nameError = '*Please enter name'
        if (!number.trim()) {
            error.numberError = '*Please enter mobile number'
        } else if (!/^\d{10}$/.test(number)) {
            error.numberError = '*Please enter a valid 10-digit number'
        }
        if (!subject.trim()) error.subjectError = '*Please enter subject'
        if (!message.trim()) error.messageError = '*Please enter your message'

        updateCState({ ...cState, errors: error })
        return Object.keys(error).length === 0
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        if (!handleValidation()) return

        setSubmitting(true)
        try {
            const payload = { name, phoneNumber: number, subject, message }
            const res = await axios.post('https://poultryfy.com/api/v1/user/landing/contactUs', payload)
            if (Number(res?.data?.code) === 200) {
                toast.success(res?.data?.message || 'Thanks! We will get back to you soon.', toastOptions)
                updateCState(initialState)
            } else {
                toast.error(res?.data?.message || 'Something went wrong. Please try again.', toastOptions)
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Could not send your message. Please try again later.', toastOptions)
        } finally {
            setSubmitting(false)
        }
    }

    const fieldClass = (key) => `field${errors[key] ? ' has-error' : ''}`

    return (
        <form className="contact-form" onSubmit={handleSubmit} noValidate>
            <h3>Contact With Us</h3>
            <div className="form-row">
                <div className={fieldClass('nameError')}>
                    <label htmlFor="cf-name">Name <span>*</span></label>
                    <input id="cf-name" type="text" name="name" placeholder="Your name" value={name} onChange={handleInputChange} autoComplete="name" />
                    {errors.nameError && <span className="field-error">{errors.nameError}</span>}
                </div>
                <div className={fieldClass('numberError')}>
                    <label htmlFor="cf-number">Mobile Number <span>*</span></label>
                    <input id="cf-number" type="tel" inputMode="numeric" maxLength={10} name="number" placeholder="10-digit number" value={number} onChange={handleInputChange} autoComplete="tel-national" />
                    {errors.numberError && <span className="field-error">{errors.numberError}</span>}
                </div>
            </div>
            <div className={fieldClass('subjectError')}>
                <label htmlFor="cf-subject">Subject <span>*</span></label>
                <input id="cf-subject" type="text" name="subject" placeholder="Subject" value={subject} onChange={handleInputChange} />
                {errors.subjectError && <span className="field-error">{errors.subjectError}</span>}
            </div>
            <div className={fieldClass('messageError')}>
                <label htmlFor="cf-message">Your Message <span>*</span></label>
                <textarea id="cf-message" name="message" placeholder="Type your message..." value={message} onChange={handleInputChange} />
                {errors.messageError && <span className="field-error">{errors.messageError}</span>}
            </div>
            <button type="submit" className="btn btn-primary btn-block" disabled={submitting}>
                {submitting ? 'Sending…' : 'Send Message'}
            </button>
        </form>
    )
}

export default ContactForm
